import { render } from "./ActionComponent.vue?vue&type=template&id=47cd3269&scoped=true"
import script from "./ActionComponent.vue?vue&type=script&lang=js"
export * from "./ActionComponent.vue?vue&type=script&lang=js"

import "./ActionComponent.vue?vue&type=style&index=0&id=47cd3269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cd3269"]])

export default __exports__